import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { formatInventoryLocation } from "../utils"

import type { WarehouseShelving } from "@/graphql/codegen/graphql"

export interface InventoryWorkOrderLocationProps {
  warehouseShelving?: WarehouseShelving | null
  location?: string | null
}

export const InventoryWorkOrderLocation: FC<InventoryWorkOrderLocationProps> = ({ warehouseShelving, location }) => {
  if (!warehouseShelving) {
    return formatInventoryLocation(location)
  }

  return (
    <Box className='flex flex-col'>
      <Typography variant='h6' component='div' className='font-bold'>
        Aisle: {warehouseShelving.aisleCode}
      </Typography>
      <Box>Shelf: {warehouseShelving.sectionCode}</Box>
      <Box>Bin: {warehouseShelving.binNumber}</Box>
    </Box>
  )
}
